/*
Except the below locales, Traduki will return short locale.json files
   rewriteLocales:
      en-GB: en-GB
      en-US: en-US
      en-ZZ: en-ZZ
      pt-PT: pt-PT
      pt-BR: pt-BR
      zh-CN: zh-CN
      zh-TW: zh-TW
*/
// Enable this once Traduki starts returning short locale files
const getLocaleFileFromShortLocale = (locale: string): Record<string, string> | undefined => {
	switch (locale) {
		case 'cs':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/cs.json');
		case 'da':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/da.json');
		case 'de':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/de.json');
		case 'en':
		case 'en-us':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/en.json');
		case 'en-gb':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/en-GB.json');
		case 'es':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/es.json');
		case 'fi':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/fi.json');
		case 'fr':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/fr.json');
		case 'hr':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/hr.json');
		case 'hu':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/hu.json');
		case 'it':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/it.json');
		case 'ja':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/ja.json');
		case 'ko':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/ko.json');
		case 'nb':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/nb.json');
		case 'nl':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/nl.json');
		case 'pl':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/pl.json');
		case 'pt-br':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/pt-BR.json');
		case 'ru':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/ru.json');
		case 'sk':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/sk.json');
		case 'sv':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/sv.json');
		case 'th':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/th.json');
		case 'tr':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/tr.json');
		case 'uk':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/uk.json');
		case 'vi':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/vi.json');
		case 'zh-cn':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/zh-CN.json');
		case 'zh-tw':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/generated/zh-TW.json');
		default:
			console.warn(
				`No translation file found for locale: ${locale}. Falling back to the default locale (en-US).`,
			);
			return undefined;
	}
};

// Parcel will import each case into a separate chunk, so it won't increase the bundle size with all languages included.
// Parcel can't dynamically import JSON files, so we use a switch statement to import the correct file based on the locale.
// TODO: please fix this with dynamic imports if you find a way to make it work with Parcel, since this solution could be fragile when translation language scales.
export const getMessagesForLocale = async (
	lowerCasedLocale: string,
): Promise<Record<string, string> | undefined> => {
	// This dynamic import approach doesn't work with Parcel, so we use a switch statement instead.
	// Please fix this if you find a way to make it work with Parcel, since this solution could be fragile when translation language scales.
	// try {
	// 	return await import(`./${lowerCasedLocale}.json`);
	// } catch (e1) {
	// 	console.warn(
	// 		`No translation file found for locale file: ${lowerCasedLocale}.json. Falling back to rule-based imports.`,
	// 	);
	// }

	return getLocaleFileFromShortLocale(lowerCasedLocale);
};
